var exports = {
  "Gt": "ChannelOriginIcon.module__frame___bmtkdE",
  "z5": "ChannelOriginIcon.module__cutout___bmtkdE",
  "qS": "ChannelOriginIcon.module__badge___bmtkdE",
  "Nw": "ChannelOriginIcon.module__badgeHighlighted___bmtkdE",
  "rF": "ChannelOriginIcon.module__badgeIcon___bmtkdE",
  "YQ": "ChannelOriginIcon.module__fallbackIcon___bmtkdE",
  "tR": "ChannelOriginIcon.module__fallbackIconHighlighted___bmtkdE",
};

module.exports = exports;
